import request from '../request'

/**
 * 获取打卡表单选项（打卡类型下拉列表等）。
 * 主后台走 /api/admin 前缀直连 3000（3000 与 3001 共用 MySQL 库），
 * 避免命中 nginx 分流到 3001 后因小程序 token 鉴权返回 401。
 * @returns {Promise<Array>} 表单选项数组
 */
export function fetchFormOptions() {
  return request({
    url: '/api/admin/form-options',
    method: 'GET',
  })
}

/**
 * 获取首页打卡记录列表（带查询参数）。
 * @param {Object} params 查询参数（date, page, pageSize 等）。
 * @returns {Promise<{list: Array, total: number}>}
 */
export function fetchHomeRecords(params) {
  return request({
    url: '/api/admin/home-records',
    method: 'GET',
    params,
  })
}

/**
 * 获取单条打卡记录详情。
 * @param {string|number} recordId 记录 ID。
 * @returns {Promise<Object>} 记录详情
 */
export function fetchRegisterRecordDetail(recordId) {
  return request({
    url: `/api/admin/register-records/${recordId}`,
    method: 'GET',
  })
}

/**
 * 更新打卡记录。
 * @param {string|number} recordId 记录 ID。
 * @param {Object} payload 更新数据。
 * @returns {Promise}
 */
export function updateRegisterRecord(recordId, payload) {
  return request({
    url: `/api/admin/register-records/${recordId}`,
    method: 'PUT',
    data: payload,
  })
}

/**
 * 删除打卡记录。
 * @param {string|number} recordId 记录 ID。
 * @returns {Promise}
 */
export function deleteRegisterRecord(recordId) {
  return request({
    url: `/api/admin/register-records/${recordId}`,
    method: 'DELETE',
  })
}
